<template>
    <hr :class="['ihr',cfg.class]" :width='cfg.width' :size='cfg.size' :color='cfg.color'></hr>
</template>
<script>
    export default {
        name:"ihr",
        //其中 width 规定线条的长度，还可以是百分比；color 表示颜色，size 表示厚度；
        props: {
            cfg: {
                type: Object,
                default: function () {
                    return {width:'99%',size:1,color:'#E4E4E4',class:''}
                }
            }
        },
        
        data () {
            return {}
        },
        methods:{
            
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/separatorLine.vue